import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Check if the app is in production mode
const isProduction = process.env.REACT_APP_NODE_ENV === "production";

if (isProduction) {
  console.log = function () {};
  console.warn = function () {};
  console.error = function () {};
}

// Analytics (custom tracker + GA4) are now loaded only after cookie consent
// is granted. See src/analytics/AnalyticsGate.js — mounted inside <App/>.

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
